import { Box, Button, Grid, Stack, Typography } from "@mui/material/index";
import { useTranslation } from "react-i18next";
import { useHasScope } from "../../../../config/globalConfig";
import { CBAuth, DossierTemplateDto } from "../../types";

interface CustomerBaseDossierTemplatePickerProps {
    templates: DossierTemplateDto[],
    selectedTemplateIdentifier: string
    isOrganization: boolean,
    onTemplatePicked: (templateIdentifier: string) => void,
    onAddClick: () => void,
    onBackClick: () => void
    

}
const CustomerBaseDossierTemplatePicker = ({
    templates,
    selectedTemplateIdentifier,
    isOrganization,
    onTemplatePicked,
    onAddClick,
    onBackClick
    

}: CustomerBaseDossierTemplatePickerProps) => {

    const hasScope = useHasScope;
    const { t } = useTranslation('customerbase');
    
    return (
        <Box display="flex" alignItems="center" justifyContent="center">
            {
                <Box id="box-chose-templates" sx={{display: "flex", textAlign: "center", justifyContent: "center", width: "100%"}}>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography variant={'h4'}>{isOrganization ? t("emptyState.attachment.title") : t("emptyState.document.title")}</Typography>
                        </Grid>
                        {hasScope(CBAuth.WRITE_CUSTOMER) && 
                            <Grid item xs={12}>
                                <Typography variant={'bodyLarge'}>{
                                        (isOrganization ? t("emptyState.attachment.content") : t("emptyState.document.content"))}
                                </Typography>
                            </Grid>
                        }
                        {hasScope(CBAuth.WRITE_CUSTOMER) && 
                            <Grid item xs={12}>
                                <Stack direction={"row"} spacing={1} justifyContent={"center"}>
                                    {!selectedTemplateIdentifier && templates.map((tID, index) =>
                                            <Button
                                                key={`template-btn-${index}`}
                                                color={"accent"}
                                                onClick={() => onTemplatePicked(tID.identifier)}
                                            >
                                                {t("emptyState.buttonLabelsAttachment.addDossier")}
                                            </Button>
                                        )
                                    }
                                    {!!selectedTemplateIdentifier && 
                                        <Button 
                                            color={"accent"}
                                            onClick={onBackClick}
                                        >
                                            {t("emptyState.buttonLabels.back")}
                                        </Button>
                                    }
                                    {!!selectedTemplateIdentifier && 
                                        <Button 
                                            color={"accent"}
                                            onClick={onAddClick}
                                        >
                                            {t("emptyState.buttonLabelsAttachment.addDocument")}
                                        </Button>
                                    }
                                </Stack>
                            </Grid>
                        }
                    </Grid>
                </Box> 
            }
        </Box>
    )


}

export default CustomerBaseDossierTemplatePicker;